// Dictionnaires de traduction FR / EN / PL
// Structure : { fr: {...}, en: {...}, pl: {...} }

const translations = {
  fr: {
    nav: {
      home: 'Accueil',
      solutions: 'Solutions',
      services: 'Services',
      niroprod: 'NIROPROD',
      whyUs: 'Pourquoi nous',
      contact: 'Contact',
      techmill: 'TECHMILL'
    },
    hero: {
      badge: 'IA & Automatisation Industrielle',
      titleStart: 'Transformez votre entreprise avec',
      titleHighlight: "l'IA et l'automatisation",
      titleEnd: 'sur mesure.',
      subtitle: "AI Dynamics accompagne les PME dans leur transformation digitale en automatisant leurs processus administratifs et industriels. Gagnez du temps, réduisez vos coûts et boostez votre productivité.",
      ratingText: '5/5 — Satisfaction clients',
      ctaPrimary: 'Parlez à nos experts',
      ctaSecondary: 'Découvrir nos solutions',
      statSatisfaction: 'Satisfaction',
      statProcesses: 'Processus automatisés',
      statProductivity: 'Productivité'
    },
    homeServices: {
      label: 'Nos Solutions',
      titleStart: "Automatiser n'a jamais été",
      titleHighlight: 'aussi simple',
      subtitle: 'Des solutions personnalisées pour réduire vos coûts, améliorer votre productivité et simplifier vos opérations.',
      automationTitle: 'Automatisation Administrative',
      automationDesc: "Simplifiez vos tâches quotidiennes grâce à nos solutions d'automatisation sur mesure. Réduisez les erreurs et gagnez du temps précieux.",
      aiTitle: 'Analyse & IA',
      aiDesc: "Outils avancés d'intelligence artificielle pour vos processus opérationnels.",
      niroprodTitle: 'NIROPROD',
      niroprodDesc: 'ERP propriétaire pour la gestion complète de votre production.',
      techmillTitle: 'TECHMILL by AI Dynamics',
      techmillDesc: 'Sous-traitance industrielle multi-procédés : usinage CNC, soudure, traitement de surface et assemblage de pièces de précision.',
      learnMore: 'En savoir plus',
      explore: 'Explorer',
      discover: 'Découvrir',
      discoverTechmill: 'Découvrir TECHMILL'
    },
    homeWhy: {
      fastTitle: 'Résultats Rapides',
      fastDesc: 'Des résultats concrets dès les premières semaines de déploiement.',
      reliabilityTitle: 'Fiabilité',
      reliabilityDesc: 'Solutions robustes et sécurisées, testées en environnement industriel.',
      performanceTitle: 'Performance',
      performanceDesc: 'Optimisation mesurable de vos processus et réduction des coûts.'
    },
    clientLogos: {
      title: 'Ils nous font confiance'
    },
    caseStudies: {
      label: 'Résultats concrets',
      titleStart: 'Des',
      titleHighlight: 'résultats mesurables',
      subtitle: 'Chaque projet est mesuré et piloté par des indicateurs concrets. Voici quelques exemples de transformations réalisées.',
      cta: 'Discutons de votre projet'
    },
    testimonial: {
      label: 'Témoignage',
      quote: '« Grâce à AI Dynamics, notre efficacité a été multipliée. Leur expertise en automatisation et IA a transformé notre entreprise. Une collaboration précieuse et innovante ! »',
      author: 'Client partenaire'
    },
    faq: {
      label: 'FAQ',
      titleStart: 'Questions',
      titleHighlight: 'fréquentes',
      subtitle: 'Les réponses aux questions que nos clients nous posent le plus souvent.'
    },
    cta: {
      titleStart: 'Prêt à',
      titleHighlight: 'transformer',
      titleEnd: 'votre entreprise ?',
      subtitle: "Concentrez-vous sur l'essentiel. Nous nous occupons de l'automatisation.",
      contact: 'Contactez-nous',
      services: 'Voir nos services'
    },
    footer: {
      tagline: 'Transformez votre entreprise avec nos solutions innovantes en automatisation et intelligence artificielle.',
      solutions: 'Solutions',
      company: 'Entreprise',
      newsletter: 'Newsletter',
      newsletterDesc: 'Restez informé de nos dernières innovations.',
      newsletterPlaceholder: 'Votre adresse e-mail',
      newsletterSuccess: 'Merci pour votre inscription !',
      newsletterError: 'Une erreur est survenue. Réessayez.',
      rights: 'Tous droits réservés.',
      legal: 'Mentions légales',
      privacy: 'Confidentialité'
    },
    cookieBanner: {
      title: 'Nous respectons votre vie privée',
      text: 'Nous utilisons des cookies pour améliorer votre expérience et analyser le trafic. Vous pouvez accepter, refuser ou consulter notre',
      policyLink: 'politique de confidentialité',
      reject: 'Refuser',
      accept: 'Accepter'
    },
    notFound: {
      titleStart: 'Page',
      titleHighlight: 'introuvable',
      subtitle: "Désolé, la page que vous recherchez n'existe pas ou a été déplacée. Retrouvez votre chemin parmi nos solutions.",
      home: "Retour à l'accueil",
      contact: 'Nous contacter',
      popular: 'Pages populaires :'
    },
    servicesPage: {
      label: 'Services',
      titleStart: 'Nos Services',
      titleHighlight: 'Innovants',
      subtitle: 'Automatisation et Intelligence Artificielle pour optimiser vos processus et réduire vos coûts.',
      ctaTitle: 'Prêt à',
      ctaTitleHighlight: 'transformer',
      ctaTitleEnd: 'votre entreprise ?',
      ctaSubtitle: 'Contactez-nous pour une analyse gratuite de vos besoins.',
      ctaButton: 'Demander une analyse gratuite'
    },
    whyUsPage: {
      label: 'Pourquoi nous',
      titleStart: "Une équipe d'experts",
      titleHighlight: 'à votre service',
      subtitle: 'Chez AI Dynamics, nous concevons des solutions innovantes orientées résultats pour répondre à vos besoins spécifiques.',
      statsSatisfaction: 'Satisfaction client',
      statsProcesses: 'Processus automatisés',
      statsProductivity: 'Productivité en moyenne',
      statsSupport: 'Support technique',
      valuesLabel: 'Nos Valeurs',
      valuesTitleStart: 'Ce qui nous',
      valuesTitleHighlight: 'différencie',
      approachLabel: 'Notre Approche',
      approachTitleStart: 'Simplifiez et',
      approachTitleHighlight: 'automatisez',
      approachDesc: "Notre équipe analyse vos processus existants, identifie les opportunités d'amélioration et déploie des solutions sur mesure. Avec une approche orientée résultats, nous intégrons les meilleures technologies pour une automatisation fluide et performante.",
      stepAuditTitle: 'Audit & Analyse',
      stepAuditDesc: "Étude de vos processus et identification des axes d'amélioration.",
      stepDesignTitle: 'Conception',
      stepDesignDesc: 'Développement de solutions personnalisées adaptées à votre métier.',
      stepDeployTitle: 'Déploiement & Suivi',
      stepDeployDesc: 'Mise en production, formation et accompagnement continu.',
      ctaTitleStart: 'Découvrez comment nos solutions',
      ctaTitleHighlight: 'transforment',
      ctaTitleEnd: 'les entreprises',
      ctaButton: 'Parlez à nos experts'
    },
    contactPage: {
      label: 'Contact',
      titleHighlight: 'Contactez',
      titleEnd: '-nous',
      subtitle: 'Nous sommes là pour répondre à vos besoins en automatisation.',
      leftTitle: 'Parlons de votre projet',
      leftText: "Que vous souhaitiez automatiser vos processus, découvrir NIROPROD ou obtenir un devis pour TECHMILL, notre équipe est prête à vous accompagner.",
      labelEmail: 'Email',
      labelPhone: 'Téléphone',
      phoneValue: 'Sur rendez-vous',
      labelLocation: 'Localisation',
      locationValue: 'France',
      formFirstName: 'Votre prénom',
      formEmail: 'Votre adresse email *',
      formSubject: 'Sujet',
      formSubjectDefault: 'Sélectionnez un sujet',
      formSubjectServices: 'Services & Automatisation',
      formSubjectNiroprod: 'NIROPROD - Démo ERP',
      formSubjectTechmill: 'TECHMILL - Devis usinage',
      formSubjectOther: 'Autre',
      formMessage: 'Votre message *',
      formMessagePlaceholder: 'Décrivez votre projet ou besoin...',
      formSubmit: 'Envoyer votre demande',
      formSubmitting: 'Envoi en cours...',
      errorEmailRequired: "L'email est requis",
      errorEmailInvalid: 'Email invalide',
      errorMessageRequired: 'Le message est requis',
      errorMessageShort: 'Minimum 10 caractères',
      successTitle: 'Message envoyé !',
      successText: 'Merci pour votre message. Nous reviendrons vers vous dans les plus brefs délais.',
      errorTitle: "Erreur d'envoi",
      errorText: 'Une erreur est survenue. Vous pouvez nous contacter directement à'
    },
    niroprodPage: {
      label: 'ERP Intelligent',
      subtitle: 'Système de gestion de production sur mesure pour les PME industrielles. Conçu sur la plateforme Claris FileMaker — flexible, rapide à déployer et facile à faire évoluer.',
      highlightDeployed: 'Déployé chez Kubitech Industrie',
      highlightFilemaker: 'Basé sur Claris FileMaker',
      highlightConnected: 'Connecté à vos outils (n8n, Gmail, etc.)',
      highlightIpads: 'iPads en atelier pour le suivi temps réel',
      ctaDemo: 'Demander une démo',
      introLabel: 'Sur mesure avant tout',
      introTitleStart: 'Un logiciel qui',
      introTitleHighlight: 'reflète votre façon de travailler',
      introText: "Nous concevons des systèmes individuels, adaptés aux besoins concrets de votre organisation — sans fonctions inutiles. NIROPROD relie les données de votre service commercial, du bureau de planification, du magasin et des machines de l'atelier en une seule plateforme cohérente.",
      workflowLabel: 'Workflow',
      workflowTitleStart: 'De la commande client à',
      workflowTitleHighlight: "l'ordre de fabrication",
      workflowSubtitle: 'NIROPROD soutient le pilotage réel de la production, étape par étape.',
      step1Title: 'Enregistrement des commandes',
      step1Desc: 'Saisie des commandes avec positions, dates de livraison, devises et priorités. Chaque ligne est tracée individuellement.',
      step2Title: 'Agrégation multi-commandes',
      step2Desc: "La vue « Positions de commandes » regroupe toutes les positions de toutes les commandes avec statut, priorité et dates de livraison/production.",
      step3Title: 'Cœur du système : composition des ordres',
      step3Desc: 'Vous pouvez répartir les commandes en positions individuelles et les organiser librement en ordres de fabrication optimisés.',
      step4Title: 'Ordre de fabrication = centre de commande',
      step4Desc: "Les positions sont reliées à la technologie, aux statuts d'étapes et à la disponibilité des ressources. Tout est visible d'un seul écran.",
      galleryLabel: "L'application",
      galleryTitleStart: 'Découvrez',
      galleryTitleHighlight: 'NIROPROD',
      galleryTitleEnd: 'en images',
      gallerySubtitle: "De la commande client à la livraison, NIROPROD couvre l'ensemble de votre chaîne de production.",
      planningLabel: 'Planification',
      planningTitleStart: 'Planning par',
      planningTitleHighlight: 'jour et par poste',
      planningText: "Le tableau de planification affiche la charge de chaque machine et de chaque poste de travail sur un horizon de plusieurs semaines, avec le pourcentage d'occupation et le temps disponible.",
      benefitBottlenecksTitle: 'Détection rapide des goulots',
      benefitBottlenecksDesc: "Identifiez en un coup d'œil les postes surchargés.",
      benefitShipmentsTitle: 'Sécurisation des expéditions critiques',
      benefitShipmentsDesc: 'Vérifiez que les commandes urgentes sont garanties malgré la charge.',
      benefitComparisonTitle: 'Comparaison planifié vs réel',
      benefitComparisonDesc: 'Les temps planifiés sont confrontés aux données réelles collectées en atelier.',
      shopfloorLabel: 'Atelier connecté',
      shopfloorTitleStart: 'Des iPads aux',
      shopfloorTitleHighlight: 'postes de travail',
      shopfloorText: "Chaque opérateur dispose d'un iPad équipé de FileMaker Go. Il visualise la liste des opérations planifiées avec des boutons clairs pour démarrer, mettre en pause ou terminer une tâche. Les temps remontent automatiquement dans le système central.",
      featuresLabel: 'Fonctionnalités',
      featuresTitleStart: 'Tout ce dont votre entreprise',
      featuresTitleHighlight: 'a besoin',
      featuresSubtitle: 'Un système adapté à votre façon de travailler — pas l\'inverse.',
      futureLabel: "Système prêt pour l'avenir",
      futureTitleStart: 'Compatible avec',
      futureTitleHighlight: "l'intelligence artificielle",
      futureText: "NIROPROD est conçu pour intégrer des algorithmes d'optimisation et d'intelligence artificielle. Le planning peut être généré automatiquement en fonction de vos contraintes : disponibilité des machines, priorités client, délais et compétences des opérateurs.",
      whyLabel: 'Pourquoi NIROPROD',
      whyTitleStart: "Les avantages d'un",
      whyTitleHighlight: 'système sur mesure',
      whyText: "NIROPROD évolue avec votre entreprise. Grâce à la plateforme Claris FileMaker, le système s'adapte à vos nouveaux besoins sans migration ni remplacement complet.",
      ctaTitleStart: 'Prêt à',
      ctaTitleHighlight: 'digitaliser',
      ctaTitleEnd: 'votre production ?',
      ctaSubtitle: 'Découvrez comment NIROPROD peut transformer votre gestion industrielle.',
      ctaButton: 'Planifier une démonstration'
    },
    legal: {
      label: 'Informations',
      titleStart: 'Mentions',
      titleHighlight: 'légales',
      editorTitle: 'Éditeur du site',
      editorText: 'Le site <strong>ai-dynamics.fr</strong> est édité par AI Dynamics.',
      editorEmail: 'Email',
      editorPhone: 'Téléphone',
      directorTitle: 'Directeur de la publication',
      directorText: "Le directeur de la publication est le représentant légal d'AI Dynamics.",
      hostingTitle: 'Hébergement',
      hostingText: 'Le site est hébergé par un prestataire respectant les normes européennes en matière de protection des données.',
      ipTitle: 'Propriété intellectuelle',
      ipText1: "L'ensemble du contenu du site (textes, images, logos, vidéos, illustrations) est la propriété exclusive d'AI Dynamics ou de ses partenaires. Toute reproduction, représentation ou diffusion, totale ou partielle, est strictement interdite sans autorisation écrite préalable.",
      ipText2: "Le logiciel NIROPROD est un produit propriétaire d'AI Dynamics, basé sur la plateforme Claris FileMaker.",
      linksTitle: 'Liens hypertextes',
      linksText: 'Le site peut contenir des liens vers d\'autres sites internet. AI Dynamics ne saurait être tenu responsable du contenu de ces sites.',
      lawTitle: 'Droit applicable',
      lawText: 'Le présent site est soumis au droit français. En cas de litige, les tribunaux français seront seuls compétents.',
      contactTitle: 'Contact',
      contactText: 'Pour toute question relative aux mentions légales, contactez-nous à'
    },
    privacy: {
      label: 'Confidentialité',
      titleStart: 'Politique de',
      titleHighlight: 'confidentialité',
      intro: "AI Dynamics s'engage à protéger la vie privée de ses utilisateurs. Cette politique décrit comment nous collectons, utilisons et protégeons vos données personnelles, conformément au Règlement Général sur la Protection des Données (RGPD).",
      dataTitle: 'Données collectées',
      dataIntro: 'Nous collectons uniquement les données nécessaires à nos services :',
      data1: 'Nom, prénom et adresse email (formulaire de contact)',
      data2: 'Numéro de téléphone (si renseigné)',
      data3: "Nom de l'entreprise (formulaire de devis)",
      data4: 'Données techniques (cookies, adresse IP, navigateur)',
      purposeTitle: 'Finalité du traitement',
      purposeIntro: 'Vos données sont utilisées pour :',
      purpose1: 'Répondre à vos demandes de contact ou de devis',
      purpose2: 'Vous envoyer notre newsletter (avec votre consentement)',
      purpose3: 'Améliorer nos services et notre site web',
      purpose4: 'Respecter nos obligations légales',
      retentionTitle: 'Durée de conservation',
      retentionText: 'Vos données sont conservées pour la durée nécessaire à la finalité du traitement, et au maximum 3 ans à compter du dernier contact.',
      rightsTitle: 'Vos droits',
      rightsIntro: 'Conformément au RGPD, vous disposez des droits suivants :',
      right1Strong: "Droit d'accès",
      right1Text: 'à vos données personnelles',
      right2Strong: 'Droit de rectification',
      right2Text: "en cas d'inexactitude",
      right3Strong: "Droit à l'effacement",
      right3Text: 'de vos données',
      right4Strong: 'Droit à la limitation',
      right4Text: 'du traitement',
      right5Strong: 'Droit à la portabilité',
      right5Text: 'de vos données',
      right6Strong: "Droit d'opposition",
      right6Text: 'au traitement',
      rightsContact: 'Pour exercer ces droits, contactez-nous à',
      cookiesTitle: 'Cookies',
      cookiesText: "Notre site utilise des cookies essentiels au bon fonctionnement et, avec votre consentement, des cookies analytiques pour améliorer l'expérience utilisateur. Vous pouvez gérer vos préférences à tout moment via le bandeau de cookies.",
      securityTitle: 'Sécurité',
      securityText: "Nous mettons en œuvre des mesures techniques et organisationnelles appropriées pour protéger vos données personnelles contre tout accès, divulgation ou modification non autorisés.",
      updatesTitle: 'Modifications',
      updatesText: 'Cette politique peut être mise à jour. Nous vous encourageons à la consulter régulièrement.',
      contactTitle: 'Contact',
      contactText: 'Pour toute question relative à vos données personnelles, contactez notre équipe à'
    },
    a11y: {
      skipToContent: 'Aller au contenu principal',
      backToTop: 'Retour en haut de la page'
    },
    blog: {
      navLabel: 'Blog',
      label: 'Actualités & Insights',
      titleStart: 'Le blog',
      titleHighlight: 'AI Dynamics',
      subtitle: "Analyses, retours d'expérience et conseils pratiques sur l'automatisation, l'IA et l'industrie 4.0.",
      categoryAll: 'Tous',
      categoryAutomation: 'Automatisation',
      categoryAi: 'Intelligence Artificielle',
      categoryCaseStudy: 'Cas clients',
      categoryTechmill: 'TECHMILL',
      categoryTech: 'Tech',
      readTime: 'min de lecture',
      readMore: "Lire l'article",
      backToBlog: 'Retour au blog',
      shareArticle: 'Partager cet article',
      relatedTitle: 'À lire également',
      ctaTitle: "Besoin d'un accompagnement ?",
      ctaSubtitle: "Nos experts sont là pour transformer vos processus.",
      ctaButton: 'Contactez-nous',
      notFoundTitle: 'Article introuvable',
      notFoundText: "Cet article n'existe pas ou a été déplacé.",
      publishedOn: 'Publié le'
    },
    roi: {
      label: 'Calculateur ROI',
      titleStart: 'Combien pourriez-vous',
      titleHighlight: 'économiser',
      titleEnd: '?',
      subtitle: "Estimez vos économies potentielles en quelques secondes. Les résultats sont basés sur des moyennes constatées chez nos clients.",
      inputTitle: 'Votre situation actuelle',
      currencyLabel: 'Devise',
      hoursLabel: 'Heures perdues par semaine sur des tâches répétitives',
      hoursHelp: 'Saisie de données, emails, reporting, planification...',
      employeesLabel: 'Nombre de personnes concernées',
      hourlyCostLabel: 'Coût horaire moyen',
      hourlyCostHelp: 'Salaire + charges par personne',
      automationLabel: "% de tâches automatisables",
      automationHelp: "En moyenne, nos projets automatisent 60 à 80 % des tâches ciblées",
      resultsTitle: 'Vos gains potentiels',
      weeklyHours: 'heures/semaine récupérées',
      monthlySavings: 'économies/mois',
      yearlySavings: "économies/an",
      paybackTitle: 'Retour sur investissement',
      paybackValue: "mois estimés",
      paybackDesc: "Basé sur un projet d'automatisation moyen",
      cta: 'Obtenir une estimation précise',
      disclaimer: "Ces estimations sont indicatives. Un audit gratuit permet de vous donner un chiffrage précis pour votre cas."
    },
    chatbot: {
      openLabel: 'Ouvrir le chat IA',
      title: 'Ada',
      subtitle: 'Assistante IA — AI Dynamics',
      status: 'En ligne',
      welcome: "👋 Bonjour ! Je suis Ada, votre assistante IA. Je peux vous aider à découvrir nos solutions NIROPROD, TECHMILL ou nos services d'automatisation. Que souhaitez-vous savoir ?",
      placeholder: 'Posez votre question...',
      sendLabel: 'Envoyer',
      typing: 'Ada écrit',
      quickActions: 'Questions fréquentes :',
      quickNiroprod: 'Qu\'est-ce que NIROPROD ?',
      quickTechmill: 'Parlez-moi de TECHMILL',
      quickPrice: 'Quels sont vos tarifs ?',
      quickDemo: 'Je veux une démo',
      quickContact: 'Comment vous contacter ?',
      disclaimer: "Démo IA — pour un conseil précis, ",
      disclaimerLink: 'contactez nos experts',
      errorFallback: "Désolée, une erreur est survenue. Vous pouvez aussi nous écrire à contact@ai-dynamics.fr",
      poweredBy: 'Propulsé par AI Dynamics'
    },
    techmillPage: {
      navBack: 'AI Dynamics',
      navCta: 'Demander un devis',
      heroBadge: 'Sous-traitance industrielle',
      heroTitleStart: "Votre partenaire pour l'usinage de",
      heroTitleHighlight: 'pièces de précision',
      heroSubtitle: 'TECHMILL by AI Dynamics propose la sous-traitance complète de pièces mécaniques : usinage, soudure, traitement de surface et assemblage. Qualité, délais, compétitivité.',
      heroCtaQuote: 'Demander un devis',
      heroCtaCapabilities: 'Nos capacités',
      servicesLabel: 'Nos Capacités',
      servicesTitleStart: 'Multi-procédés,',
      servicesTitleHighlight: 'une seule équipe',
      servicesSubtitle: "De la matière première à la pièce finie, nous gérons l'ensemble de la chaîne de production.",
      advantagesLabel: 'Pourquoi TECHMILL',
      advantagesTitleStart: "L'avantage",
      advantagesTitleHighlight: 'AI Dynamics',
      advantagesText: "TECHMILL combine l'expertise industrielle avec les outils d'automatisation d'AI Dynamics. Résultat : des délais optimisés, une traçabilité complète et une communication fluide.",
      devisLabel: 'Devis',
      devisTitleStart: 'Demandez votre',
      devisTitleHighlight: 'devis',
      devisSubtitle: 'Décrivez votre besoin et recevez une proposition sous 24h.',
      formCompany: 'Entreprise *',
      formCompanyPlaceholder: 'Votre entreprise',
      formEmail: 'Email *',
      formMaterial: 'Matière',
      formMaterialDefault: 'Sélectionnez',
      formQuantity: 'Quantité',
      formQuantityPlaceholder: 'Ex: 50 pièces',
      formDesc: 'Description du besoin *',
      formDescPlaceholder: 'Décrivez les pièces, tolérances, traitements souhaités...',
      formUpload: 'Glissez vos fichiers techniques ici (plans, STEP, PDF) — Bientôt disponible',
      formSubmit: 'Envoyer la demande de devis',
      footerTagline: 'Sous-traitance industrielle multi-procédés.'
    }
  },

  en: {
    nav: {
      home: 'Home',
      solutions: 'Solutions',
      services: 'Services',
      niroprod: 'NIROPROD',
      whyUs: 'Why us',
      contact: 'Contact',
      techmill: 'TECHMILL'
    },
    hero: {
      badge: 'AI & Industrial Automation',
      titleStart: 'Transform your business with',
      titleHighlight: 'AI and tailored automation',
      titleEnd: '',
      subtitle: 'AI Dynamics supports SMEs in their digital transformation by automating their administrative and industrial processes. Save time, reduce costs and boost productivity.',
      ratingText: '5/5 — Customer satisfaction',
      ctaPrimary: 'Talk to our experts',
      ctaSecondary: 'Discover our solutions',
      statSatisfaction: 'Satisfaction',
      statProcesses: 'Automated processes',
      statProductivity: 'Productivity'
    },
    homeServices: {
      label: 'Our Solutions',
      titleStart: 'Automation has never been',
      titleHighlight: 'this simple',
      subtitle: 'Customized solutions to reduce your costs, improve productivity and simplify operations.',
      automationTitle: 'Administrative Automation',
      automationDesc: 'Simplify your daily tasks with custom automation. Reduce errors and save valuable time.',
      aiTitle: 'Analytics & AI',
      aiDesc: 'Advanced artificial intelligence tools for your operational processes.',
      niroprodTitle: 'NIROPROD',
      niroprodDesc: 'Proprietary ERP for the complete management of your production.',
      techmillTitle: 'TECHMILL by AI Dynamics',
      techmillDesc: 'Multi-process industrial subcontracting: CNC machining, welding, surface treatment and precision parts assembly.',
      learnMore: 'Learn more',
      explore: 'Explore',
      discover: 'Discover',
      discoverTechmill: 'Discover TECHMILL'
    },
    homeWhy: {
      fastTitle: 'Fast Results',
      fastDesc: 'Concrete results from the very first weeks of deployment.',
      reliabilityTitle: 'Reliability',
      reliabilityDesc: 'Robust and secure solutions, tested in industrial environments.',
      performanceTitle: 'Performance',
      performanceDesc: 'Measurable optimization of your processes and cost reduction.'
    },
    clientLogos: {
      title: 'Trusted by'
    },
    caseStudies: {
      label: 'Concrete results',
      titleStart: '',
      titleHighlight: 'Measurable results',
      subtitle: 'Every project is measured and driven by concrete KPIs. Here are some examples of transformations we delivered.',
      cta: "Let's talk about your project"
    },
    testimonial: {
      label: 'Testimonial',
      quote: '"Thanks to AI Dynamics, our efficiency has been multiplied. Their expertise in automation and AI transformed our company. A valuable and innovative partnership!"',
      author: 'Partner client'
    },
    faq: {
      label: 'FAQ',
      titleStart: 'Frequently asked',
      titleHighlight: 'questions',
      subtitle: 'Answers to the questions our clients ask most often.'
    },
    cta: {
      titleStart: 'Ready to',
      titleHighlight: 'transform',
      titleEnd: 'your business?',
      subtitle: 'Focus on what matters. We take care of automation.',
      contact: 'Contact us',
      services: 'Our services'
    },
    footer: {
      tagline: 'Transform your business with our innovative automation and AI solutions.',
      solutions: 'Solutions',
      company: 'Company',
      newsletter: 'Newsletter',
      newsletterDesc: 'Stay informed of our latest innovations.',
      newsletterPlaceholder: 'Your email address',
      newsletterSuccess: 'Thanks for subscribing!',
      newsletterError: 'An error occurred. Please try again.',
      rights: 'All rights reserved.',
      legal: 'Legal notice',
      privacy: 'Privacy policy'
    },
    cookieBanner: {
      title: 'We respect your privacy',
      text: 'We use cookies to improve your experience and analyze traffic. You can accept, reject or read our',
      policyLink: 'privacy policy',
      reject: 'Reject',
      accept: 'Accept'
    },
    notFound: {
      titleStart: 'Page',
      titleHighlight: 'not found',
      subtitle: "Sorry, the page you are looking for doesn't exist or has been moved. Find your way among our solutions.",
      home: 'Back to home',
      contact: 'Contact us',
      popular: 'Popular pages:'
    },
    servicesPage: {
      label: 'Services',
      titleStart: 'Our Innovative',
      titleHighlight: 'Services',
      subtitle: 'Automation and Artificial Intelligence to optimize your processes and reduce costs.',
      ctaTitle: 'Ready to',
      ctaTitleHighlight: 'transform',
      ctaTitleEnd: 'your business?',
      ctaSubtitle: 'Contact us for a free analysis of your needs.',
      ctaButton: 'Request a free analysis'
    },
    whyUsPage: {
      label: 'Why us',
      titleStart: 'An expert team',
      titleHighlight: 'at your service',
      subtitle: 'At AI Dynamics, we design innovative results-driven solutions to meet your specific needs.',
      statsSatisfaction: 'Customer satisfaction',
      statsProcesses: 'Automated processes',
      statsProductivity: 'Average productivity',
      statsSupport: 'Technical support',
      valuesLabel: 'Our Values',
      valuesTitleStart: 'What sets us',
      valuesTitleHighlight: 'apart',
      approachLabel: 'Our Approach',
      approachTitleStart: 'Simplify and',
      approachTitleHighlight: 'automate',
      approachDesc: 'Our team analyzes your existing processes, identifies improvement opportunities and deploys tailored solutions. With a results-oriented approach, we integrate the best technologies for seamless and high-performance automation.',
      stepAuditTitle: 'Audit & Analysis',
      stepAuditDesc: 'Study of your processes and identification of improvement areas.',
      stepDesignTitle: 'Design',
      stepDesignDesc: 'Development of customized solutions adapted to your business.',
      stepDeployTitle: 'Deployment & Support',
      stepDeployDesc: 'Production rollout, training and ongoing support.',
      ctaTitleStart: 'Discover how our solutions',
      ctaTitleHighlight: 'transform',
      ctaTitleEnd: 'businesses',
      ctaButton: 'Talk to our experts'
    },
    contactPage: {
      label: 'Contact',
      titleHighlight: 'Contact',
      titleEnd: ' us',
      subtitle: 'We are here to answer your automation needs.',
      leftTitle: "Let's talk about your project",
      leftText: 'Whether you want to automate your processes, discover NIROPROD or get a quote for TECHMILL, our team is ready to support you.',
      labelEmail: 'Email',
      labelPhone: 'Phone',
      phoneValue: 'By appointment',
      labelLocation: 'Location',
      locationValue: 'France',
      formFirstName: 'Your first name',
      formEmail: 'Your email *',
      formSubject: 'Subject',
      formSubjectDefault: 'Select a subject',
      formSubjectServices: 'Services & Automation',
      formSubjectNiroprod: 'NIROPROD - ERP Demo',
      formSubjectTechmill: 'TECHMILL - Machining quote',
      formSubjectOther: 'Other',
      formMessage: 'Your message *',
      formMessagePlaceholder: 'Describe your project or need...',
      formSubmit: 'Send your request',
      formSubmitting: 'Sending...',
      errorEmailRequired: 'Email is required',
      errorEmailInvalid: 'Invalid email',
      errorMessageRequired: 'Message is required',
      errorMessageShort: 'Minimum 10 characters',
      successTitle: 'Message sent!',
      successText: 'Thank you for your message. We will get back to you as soon as possible.',
      errorTitle: 'Sending error',
      errorText: 'An error occurred. You can contact us directly at'
    },
    niroprodPage: {
      label: 'Smart ERP',
      subtitle: 'Custom production management system for industrial SMEs. Built on the Claris FileMaker platform — flexible, quick to deploy and easy to scale.',
      highlightDeployed: 'Deployed at Kubitech Industrie',
      highlightFilemaker: 'Built on Claris FileMaker',
      highlightConnected: 'Connected to your tools (n8n, Gmail, etc.)',
      highlightIpads: 'iPads on the shop floor for real-time tracking',
      ctaDemo: 'Request a demo',
      introLabel: 'Custom above all',
      introTitleStart: 'Software that',
      introTitleHighlight: 'reflects how you work',
      introText: 'We design individual systems tailored to your organization\'s concrete needs — no unnecessary features. NIROPROD connects data from your sales team, planning office, warehouse and shop floor machines into one coherent platform.',
      workflowLabel: 'Workflow',
      workflowTitleStart: 'From customer order to',
      workflowTitleHighlight: 'production order',
      workflowSubtitle: 'NIROPROD supports real production management, step by step.',
      step1Title: 'Order registration',
      step1Desc: 'Orders are recorded with line items, delivery dates, currencies and priorities. Each line is tracked individually.',
      step2Title: 'Multi-order aggregation',
      step2Desc: 'The "Order positions" view groups all lines from all orders with status, priority, and delivery/production dates.',
      step3Title: 'Heart of the system: order composition',
      step3Desc: 'You can split orders into individual positions and freely organize them into optimized production orders.',
      step4Title: 'Production order = command center',
      step4Desc: 'Positions are linked to technology, step statuses and resource availability. Everything is visible on one screen.',
      galleryLabel: 'The application',
      galleryTitleStart: 'Discover',
      galleryTitleHighlight: 'NIROPROD',
      galleryTitleEnd: 'in pictures',
      gallerySubtitle: 'From customer order to delivery, NIROPROD covers your entire production chain.',
      planningLabel: 'Planning',
      planningTitleStart: 'Planning by',
      planningTitleHighlight: 'day and workstation',
      planningText: 'The planning board shows the load of each machine and workstation over several weeks, with occupancy percentage and available time.',
      benefitBottlenecksTitle: 'Quick bottleneck detection',
      benefitBottlenecksDesc: 'Identify overloaded stations at a glance.',
      benefitShipmentsTitle: 'Critical shipments secured',
      benefitShipmentsDesc: 'Verify that urgent orders are guaranteed despite the load.',
      benefitComparisonTitle: 'Planned vs actual comparison',
      benefitComparisonDesc: 'Planned times are compared to real data collected on the shop floor.',
      shopfloorLabel: 'Connected shop floor',
      shopfloorTitleStart: 'iPads at',
      shopfloorTitleHighlight: 'workstations',
      shopfloorText: 'Each operator has an iPad equipped with FileMaker Go. They see the list of scheduled operations with clear buttons to start, pause or complete a task. Times flow automatically back to the central system.',
      featuresLabel: 'Features',
      featuresTitleStart: 'Everything your business',
      featuresTitleHighlight: 'needs',
      featuresSubtitle: "A system tailored to your way of working — not the other way around.",
      futureLabel: 'Future-ready system',
      futureTitleStart: 'Compatible with',
      futureTitleHighlight: 'artificial intelligence',
      futureText: 'NIROPROD is designed to integrate optimization algorithms and artificial intelligence. The schedule can be generated automatically based on your constraints: machine availability, customer priorities, deadlines and operator skills.',
      whyLabel: 'Why NIROPROD',
      whyTitleStart: 'The advantages of a',
      whyTitleHighlight: 'custom system',
      whyText: "NIROPROD evolves with your business. Thanks to the Claris FileMaker platform, the system adapts to your new needs without migration or complete replacement.",
      ctaTitleStart: 'Ready to',
      ctaTitleHighlight: 'digitize',
      ctaTitleEnd: 'your production?',
      ctaSubtitle: 'Discover how NIROPROD can transform your industrial management.',
      ctaButton: 'Schedule a demo'
    },
    legal: {
      label: 'Information',
      titleStart: 'Legal',
      titleHighlight: 'notice',
      editorTitle: 'Site editor',
      editorText: 'The <strong>ai-dynamics.fr</strong> site is published by AI Dynamics.',
      editorEmail: 'Email',
      editorPhone: 'Phone',
      directorTitle: 'Publication director',
      directorText: "The publication director is the legal representative of AI Dynamics.",
      hostingTitle: 'Hosting',
      hostingText: 'The site is hosted by a provider respecting European standards for data protection.',
      ipTitle: 'Intellectual property',
      ipText1: "All site content (texts, images, logos, videos, illustrations) is the exclusive property of AI Dynamics or its partners. Any reproduction, representation or distribution, total or partial, is strictly prohibited without prior written authorization.",
      ipText2: "NIROPROD software is a proprietary product of AI Dynamics, built on the Claris FileMaker platform.",
      linksTitle: 'Hypertext links',
      linksText: 'The site may contain links to other websites. AI Dynamics cannot be held responsible for the content of these sites.',
      lawTitle: 'Applicable law',
      lawText: 'This site is subject to French law. In case of dispute, French courts shall have sole jurisdiction.',
      contactTitle: 'Contact',
      contactText: 'For any question regarding legal notices, contact us at'
    },
    privacy: {
      label: 'Privacy',
      titleStart: 'Privacy',
      titleHighlight: 'policy',
      intro: "AI Dynamics is committed to protecting the privacy of its users. This policy describes how we collect, use and protect your personal data, in compliance with the General Data Protection Regulation (GDPR).",
      dataTitle: 'Data collected',
      dataIntro: 'We only collect data necessary for our services:',
      data1: 'First name, last name and email address (contact form)',
      data2: 'Phone number (if provided)',
      data3: 'Company name (quote form)',
      data4: 'Technical data (cookies, IP address, browser)',
      purposeTitle: 'Processing purpose',
      purposeIntro: 'Your data is used to:',
      purpose1: 'Respond to your contact or quote requests',
      purpose2: 'Send our newsletter (with your consent)',
      purpose3: 'Improve our services and website',
      purpose4: 'Comply with our legal obligations',
      retentionTitle: 'Retention period',
      retentionText: 'Your data is kept for the time necessary for the processing purpose, and at most 3 years from the last contact.',
      rightsTitle: 'Your rights',
      rightsIntro: 'Under GDPR, you have the following rights:',
      right1Strong: 'Right of access',
      right1Text: 'to your personal data',
      right2Strong: 'Right of rectification',
      right2Text: 'in case of inaccuracy',
      right3Strong: 'Right to erasure',
      right3Text: 'of your data',
      right4Strong: 'Right to restriction',
      right4Text: 'of processing',
      right5Strong: 'Right to portability',
      right5Text: 'of your data',
      right6Strong: 'Right to object',
      right6Text: 'to processing',
      rightsContact: 'To exercise these rights, contact us at',
      cookiesTitle: 'Cookies',
      cookiesText: "Our site uses essential cookies for proper functioning and, with your consent, analytical cookies to improve user experience. You can manage your preferences at any time via the cookie banner.",
      securityTitle: 'Security',
      securityText: "We implement appropriate technical and organizational measures to protect your personal data against unauthorized access, disclosure or modification.",
      updatesTitle: 'Updates',
      updatesText: 'This policy may be updated. We encourage you to review it regularly.',
      contactTitle: 'Contact',
      contactText: 'For any question regarding your personal data, contact our team at'
    },
    a11y: {
      skipToContent: 'Skip to main content',
      backToTop: 'Back to top'
    },
    blog: {
      navLabel: 'Blog',
      label: 'News & Insights',
      titleStart: 'The',
      titleHighlight: 'AI Dynamics blog',
      subtitle: 'Analysis, case studies and practical advice on automation, AI and Industry 4.0.',
      categoryAll: 'All',
      categoryAutomation: 'Automation',
      categoryAi: 'Artificial Intelligence',
      categoryCaseStudy: 'Case studies',
      categoryTechmill: 'TECHMILL',
      categoryTech: 'Tech',
      readTime: 'min read',
      readMore: 'Read article',
      backToBlog: 'Back to blog',
      shareArticle: 'Share this article',
      relatedTitle: 'Related reads',
      ctaTitle: 'Need help?',
      ctaSubtitle: 'Our experts are here to transform your processes.',
      ctaButton: 'Contact us',
      notFoundTitle: 'Article not found',
      notFoundText: "This article doesn't exist or has been moved.",
      publishedOn: 'Published on'
    },
    roi: {
      label: 'ROI Calculator',
      titleStart: 'How much could you',
      titleHighlight: 'save',
      titleEnd: '?',
      subtitle: 'Estimate your potential savings in seconds. Results are based on averages observed with our clients.',
      inputTitle: 'Your current situation',
      currencyLabel: 'Currency',
      hoursLabel: 'Hours wasted per week on repetitive tasks',
      hoursHelp: 'Data entry, emails, reporting, planning...',
      employeesLabel: 'Number of people affected',
      hourlyCostLabel: 'Average hourly cost',
      hourlyCostHelp: 'Salary + charges per person',
      automationLabel: '% of tasks that can be automated',
      automationHelp: 'On average, our projects automate 60 to 80% of targeted tasks',
      resultsTitle: 'Your potential gains',
      weeklyHours: 'hours/week recovered',
      monthlySavings: 'savings/month',
      yearlySavings: 'savings/year',
      paybackTitle: 'Return on investment',
      paybackValue: 'estimated months',
      paybackDesc: 'Based on an average automation project',
      cta: 'Get a precise estimate',
      disclaimer: 'These estimates are indicative. A free audit provides precise pricing for your case.'
    },
    chatbot: {
      openLabel: 'Open AI chat',
      title: 'Ada',
      subtitle: 'AI Assistant — AI Dynamics',
      status: 'Online',
      welcome: "👋 Hi! I'm Ada, your AI assistant. I can help you discover our NIROPROD, TECHMILL solutions or our automation services. What would you like to know?",
      placeholder: 'Ask your question...',
      sendLabel: 'Send',
      typing: 'Ada is typing',
      quickActions: 'Quick questions:',
      quickNiroprod: 'What is NIROPROD?',
      quickTechmill: 'Tell me about TECHMILL',
      quickPrice: 'What are your prices?',
      quickDemo: 'I want a demo',
      quickContact: 'How to contact you?',
      disclaimer: 'AI demo — for precise advice, ',
      disclaimerLink: 'contact our experts',
      errorFallback: 'Sorry, an error occurred. You can also write to us at contact@ai-dynamics.fr',
      poweredBy: 'Powered by AI Dynamics'
    },
    techmillPage: {
      navBack: 'AI Dynamics',
      navCta: 'Request a quote',
      heroBadge: 'Industrial subcontracting',
      heroTitleStart: 'Your partner for',
      heroTitleHighlight: 'precision parts machining',
      heroSubtitle: 'TECHMILL by AI Dynamics offers complete subcontracting of mechanical parts: machining, welding, surface treatment and assembly. Quality, lead times, competitiveness.',
      heroCtaQuote: 'Request a quote',
      heroCtaCapabilities: 'Our capabilities',
      servicesLabel: 'Our Capabilities',
      servicesTitleStart: 'Multi-process,',
      servicesTitleHighlight: 'one team',
      servicesSubtitle: 'From raw material to finished part, we manage the entire production chain.',
      advantagesLabel: 'Why TECHMILL',
      advantagesTitleStart: 'The',
      advantagesTitleHighlight: 'AI Dynamics advantage',
      advantagesText: 'TECHMILL combines industrial expertise with the automation tools of AI Dynamics. The result: optimized lead times, complete traceability and smooth communication.',
      devisLabel: 'Quote',
      devisTitleStart: 'Request your',
      devisTitleHighlight: 'quote',
      devisSubtitle: 'Describe your need and receive a proposal within 24h.',
      formCompany: 'Company *',
      formCompanyPlaceholder: 'Your company',
      formEmail: 'Email *',
      formMaterial: 'Material',
      formMaterialDefault: 'Select',
      formQuantity: 'Quantity',
      formQuantityPlaceholder: 'Ex: 50 parts',
      formDesc: 'Description of need *',
      formDescPlaceholder: 'Describe the parts, tolerances, desired treatments...',
      formUpload: 'Drop your technical files here (drawings, STEP, PDF) — Coming soon',
      formSubmit: 'Send the quote request',
      footerTagline: 'Multi-process industrial subcontracting.'
    }
  },

  pl: {
    nav: {
      home: 'Strona główna',
      solutions: 'Rozwiązania',
      services: 'Usługi',
      niroprod: 'NIROPROD',
      whyUs: 'Dlaczego my',
      contact: 'Kontakt',
      techmill: 'TECHMILL'
    },
    hero: {
      badge: 'AI i Automatyzacja Przemysłowa',
      titleStart: 'Transformuj swoją firmę dzięki',
      titleHighlight: 'AI i automatyzacji',
      titleEnd: 'na miarę.',
      subtitle: 'AI Dynamics wspiera MŚP w transformacji cyfrowej, automatyzując procesy administracyjne i przemysłowe. Oszczędzaj czas, redukuj koszty i zwiększaj produktywność.',
      ratingText: '5/5 — Zadowolenie klientów',
      ctaPrimary: 'Porozmawiaj z ekspertami',
      ctaSecondary: 'Odkryj nasze rozwiązania',
      statSatisfaction: 'Zadowolenie',
      statProcesses: 'Zautomatyzowane procesy',
      statProductivity: 'Produktywność'
    },
    homeServices: {
      label: 'Nasze Rozwiązania',
      titleStart: 'Automatyzacja nigdy nie była',
      titleHighlight: 'tak prosta',
      subtitle: 'Spersonalizowane rozwiązania redukujące koszty, zwiększające produktywność i upraszczające operacje.',
      automationTitle: 'Automatyzacja Administracyjna',
      automationDesc: 'Uprość codzienne zadania dzięki automatyzacji na miarę. Redukuj błędy i zyskuj cenny czas.',
      aiTitle: 'Analiza i AI',
      aiDesc: 'Zaawansowane narzędzia sztucznej inteligencji dla Twoich procesów operacyjnych.',
      niroprodTitle: 'NIROPROD',
      niroprodDesc: 'Własny ERP do kompleksowego zarządzania produkcją.',
      techmillTitle: 'TECHMILL by AI Dynamics',
      techmillDesc: 'Wieloprocesowe podwykonawstwo przemysłowe: obróbka CNC, spawanie, obróbka powierzchniowa i montaż precyzyjnych części.',
      learnMore: 'Dowiedz się więcej',
      explore: 'Eksploruj',
      discover: 'Odkryj',
      discoverTechmill: 'Odkryj TECHMILL'
    },
    homeWhy: {
      fastTitle: 'Szybkie Rezultaty',
      fastDesc: 'Konkretne rezultaty od pierwszych tygodni wdrożenia.',
      reliabilityTitle: 'Niezawodność',
      reliabilityDesc: 'Solidne i bezpieczne rozwiązania, testowane w środowisku przemysłowym.',
      performanceTitle: 'Wydajność',
      performanceDesc: 'Mierzalna optymalizacja procesów i redukcja kosztów.'
    },
    clientLogos: {
      title: 'Zaufali nam'
    },
    caseStudies: {
      label: 'Konkretne rezultaty',
      titleStart: '',
      titleHighlight: 'Mierzalne rezultaty',
      subtitle: 'Każdy projekt jest mierzony konkretnymi wskaźnikami. Oto kilka przykładów zrealizowanych transformacji.',
      cta: 'Porozmawiajmy o Twoim projekcie'
    },
    testimonial: {
      label: 'Opinia',
      quote: '« Dzięki AI Dynamics nasza efektywność wzrosła wielokrotnie. Ich ekspertyza w automatyzacji i AI zmieniła naszą firmę. Cenna i innowacyjna współpraca! »',
      author: 'Klient partner'
    },
    faq: {
      label: 'FAQ',
      titleStart: 'Najczęściej zadawane',
      titleHighlight: 'pytania',
      subtitle: 'Odpowiedzi na pytania, które zadają nasi klienci najczęściej.'
    },
    cta: {
      titleStart: 'Gotowy do',
      titleHighlight: 'transformacji',
      titleEnd: 'Twojej firmy?',
      subtitle: 'Skup się na tym, co istotne. My zajmiemy się automatyzacją.',
      contact: 'Skontaktuj się',
      services: 'Zobacz usługi'
    },
    footer: {
      tagline: 'Transformuj swoją firmę dzięki innowacyjnym rozwiązaniom w automatyzacji i AI.',
      solutions: 'Rozwiązania',
      company: 'Firma',
      newsletter: 'Newsletter',
      newsletterDesc: 'Bądź na bieżąco z naszymi innowacjami.',
      newsletterPlaceholder: 'Twój adres e-mail',
      newsletterSuccess: 'Dziękujemy za zapisanie się!',
      newsletterError: 'Wystąpił błąd. Spróbuj ponownie.',
      rights: 'Wszelkie prawa zastrzeżone.',
      legal: 'Informacje prawne',
      privacy: 'Polityka prywatności'
    },
    cookieBanner: {
      title: 'Szanujemy Twoją prywatność',
      text: 'Używamy plików cookie, aby ulepszyć doświadczenie i analizować ruch. Możesz zaakceptować, odrzucić lub przeczytać naszą',
      policyLink: 'politykę prywatności',
      reject: 'Odrzuć',
      accept: 'Akceptuj'
    },
    notFound: {
      titleStart: 'Strona',
      titleHighlight: 'nie znaleziona',
      subtitle: 'Przepraszamy, strona której szukasz nie istnieje lub została przeniesiona. Znajdź swoją drogę wśród naszych rozwiązań.',
      home: 'Powrót na stronę główną',
      contact: 'Skontaktuj się',
      popular: 'Popularne strony:'
    },
    servicesPage: {
      label: 'Usługi',
      titleStart: 'Nasze Innowacyjne',
      titleHighlight: 'Usługi',
      subtitle: 'Automatyzacja i Sztuczna Inteligencja do optymalizacji procesów i redukcji kosztów.',
      ctaTitle: 'Gotowy do',
      ctaTitleHighlight: 'transformacji',
      ctaTitleEnd: 'Twojej firmy?',
      ctaSubtitle: 'Skontaktuj się z nami w celu bezpłatnej analizy potrzeb.',
      ctaButton: 'Poproś o bezpłatną analizę'
    },
    whyUsPage: {
      label: 'Dlaczego my',
      titleStart: 'Zespół ekspertów',
      titleHighlight: 'do Twojej dyspozycji',
      subtitle: 'W AI Dynamics projektujemy innowacyjne rozwiązania zorientowane na wyniki, aby odpowiadać na Twoje konkretne potrzeby.',
      statsSatisfaction: 'Zadowolenie klientów',
      statsProcesses: 'Zautomatyzowane procesy',
      statsProductivity: 'Średnia produktywność',
      statsSupport: 'Wsparcie techniczne',
      valuesLabel: 'Nasze Wartości',
      valuesTitleStart: 'Co nas',
      valuesTitleHighlight: 'wyróżnia',
      approachLabel: 'Nasze Podejście',
      approachTitleStart: 'Upraszczaj i',
      approachTitleHighlight: 'automatyzuj',
      approachDesc: 'Nasz zespół analizuje istniejące procesy, identyfikuje możliwości ulepszeń i wdraża rozwiązania na miarę. Z podejściem zorientowanym na wyniki integrujemy najlepsze technologie dla płynnej i wydajnej automatyzacji.',
      stepAuditTitle: 'Audyt i Analiza',
      stepAuditDesc: 'Badanie procesów i identyfikacja obszarów do ulepszenia.',
      stepDesignTitle: 'Projektowanie',
      stepDesignDesc: 'Opracowanie spersonalizowanych rozwiązań dostosowanych do Twojej branży.',
      stepDeployTitle: 'Wdrożenie i Wsparcie',
      stepDeployDesc: 'Wdrożenie produkcyjne, szkolenia i ciągłe wsparcie.',
      ctaTitleStart: 'Odkryj jak nasze rozwiązania',
      ctaTitleHighlight: 'transformują',
      ctaTitleEnd: 'firmy',
      ctaButton: 'Porozmawiaj z ekspertami'
    },
    contactPage: {
      label: 'Kontakt',
      titleHighlight: 'Skontaktuj',
      titleEnd: ' się',
      subtitle: 'Jesteśmy tutaj, aby odpowiedzieć na Twoje potrzeby w zakresie automatyzacji.',
      leftTitle: 'Porozmawiajmy o Twoim projekcie',
      leftText: 'Niezależnie czy chcesz zautomatyzować procesy, poznać NIROPROD lub otrzymać wycenę TECHMILL, nasz zespół jest gotowy Ci pomóc.',
      labelEmail: 'Email',
      labelPhone: 'Telefon',
      phoneValue: 'Po wcześniejszym umówieniu',
      labelLocation: 'Lokalizacja',
      locationValue: 'Francja',
      formFirstName: 'Twoje imię',
      formEmail: 'Twój adres email *',
      formSubject: 'Temat',
      formSubjectDefault: 'Wybierz temat',
      formSubjectServices: 'Usługi i Automatyzacja',
      formSubjectNiroprod: 'NIROPROD - Demo ERP',
      formSubjectTechmill: 'TECHMILL - Wycena obróbki',
      formSubjectOther: 'Inny',
      formMessage: 'Twoja wiadomość *',
      formMessagePlaceholder: 'Opisz swój projekt lub potrzebę...',
      formSubmit: 'Wyślij zgłoszenie',
      formSubmitting: 'Wysyłanie...',
      errorEmailRequired: 'Email jest wymagany',
      errorEmailInvalid: 'Nieprawidłowy email',
      errorMessageRequired: 'Wiadomość jest wymagana',
      errorMessageShort: 'Minimum 10 znaków',
      successTitle: 'Wiadomość wysłana!',
      successText: 'Dziękujemy za wiadomość. Odezwiemy się w możliwie najkrótszym czasie.',
      errorTitle: 'Błąd wysyłania',
      errorText: 'Wystąpił błąd. Możesz skontaktować się bezpośrednio na'
    },
    niroprodPage: {
      label: 'Inteligentny ERP',
      subtitle: 'System zarządzania produkcją na miarę dla przemysłowych MŚP. Zbudowany na platformie Claris FileMaker — elastyczny, szybki we wdrożeniu i łatwy w rozbudowie.',
      highlightDeployed: 'Wdrożony w Kubitech Industrie',
      highlightFilemaker: 'Oparty na Claris FileMaker',
      highlightConnected: 'Połączony z Twoimi narzędziami (n8n, Gmail, itp.)',
      highlightIpads: 'iPady w warsztacie do śledzenia w czasie rzeczywistym',
      ctaDemo: 'Poproś o demo',
      introLabel: 'Na miarę przede wszystkim',
      introTitleStart: 'Oprogramowanie, które',
      introTitleHighlight: 'odzwierciedla sposób pracy',
      introText: 'Projektujemy indywidualne systemy dostosowane do konkretnych potrzeb organizacji — bez zbędnych funkcji. NIROPROD łączy dane z działu sprzedaży, biura planowania, magazynu i maszyn hali w jedną spójną platformę.',
      workflowLabel: 'Przepływ pracy',
      workflowTitleStart: 'Od zamówienia klienta do',
      workflowTitleHighlight: 'zlecenia produkcyjnego',
      workflowSubtitle: 'NIROPROD wspiera rzeczywiste zarządzanie produkcją, krok po kroku.',
      step1Title: 'Rejestracja zamówień',
      step1Desc: 'Zamówienia są rejestrowane z pozycjami, terminami dostawy, walutami i priorytetami. Każda linia jest śledzona indywidualnie.',
      step2Title: 'Agregacja wielu zamówień',
      step2Desc: 'Widok "Pozycje zamówień" grupuje wszystkie linie ze wszystkich zamówień ze statusem, priorytetem i datami dostawy/produkcji.',
      step3Title: 'Serce systemu: komponowanie zleceń',
      step3Desc: 'Możesz dzielić zamówienia na pojedyncze pozycje i swobodnie organizować je w zoptymalizowane zlecenia produkcyjne.',
      step4Title: 'Zlecenie produkcyjne = centrum sterowania',
      step4Desc: 'Pozycje są powiązane z technologią, statusami etapów i dostępnością zasobów. Wszystko widoczne na jednym ekranie.',
      galleryLabel: 'Aplikacja',
      galleryTitleStart: 'Odkryj',
      galleryTitleHighlight: 'NIROPROD',
      galleryTitleEnd: 'w obrazach',
      gallerySubtitle: 'Od zamówienia klienta do dostawy, NIROPROD obejmuje cały łańcuch produkcji.',
      planningLabel: 'Planowanie',
      planningTitleStart: 'Planowanie',
      planningTitleHighlight: 'dzienne i stanowiskowe',
      planningText: 'Tablica planowania pokazuje obciążenie każdej maszyny i stanowiska w okresie kilku tygodni, z procentem zajętości i dostępnym czasem.',
      benefitBottlenecksTitle: 'Szybkie wykrywanie wąskich gardeł',
      benefitBottlenecksDesc: 'Zidentyfikuj przeciążone stanowiska jednym spojrzeniem.',
      benefitShipmentsTitle: 'Zabezpieczenie krytycznych wysyłek',
      benefitShipmentsDesc: 'Sprawdź czy pilne zamówienia są gwarantowane pomimo obciążenia.',
      benefitComparisonTitle: 'Porównanie planowany vs rzeczywisty',
      benefitComparisonDesc: 'Planowane czasy są porównywane z rzeczywistymi danymi z hali.',
      shopfloorLabel: 'Połączona hala',
      shopfloorTitleStart: 'iPady na',
      shopfloorTitleHighlight: 'stanowiskach pracy',
      shopfloorText: 'Każdy operator ma iPad z FileMaker Go. Widzi listę zaplanowanych operacji z czytelnymi przyciskami do startu, wstrzymania lub zakończenia zadania. Czasy automatycznie wracają do systemu centralnego.',
      featuresLabel: 'Funkcjonalności',
      featuresTitleStart: 'Wszystko czego Twoja firma',
      featuresTitleHighlight: 'potrzebuje',
      featuresSubtitle: 'System dostosowany do Twojego sposobu pracy — nie odwrotnie.',
      futureLabel: 'System gotowy na przyszłość',
      futureTitleStart: 'Kompatybilny ze',
      futureTitleHighlight: 'sztuczną inteligencją',
      futureText: 'NIROPROD został zaprojektowany do integracji algorytmów optymalizacji i sztucznej inteligencji. Harmonogram może być generowany automatycznie w oparciu o Twoje ograniczenia: dostępność maszyn, priorytety klientów, terminy i kompetencje operatorów.',
      whyLabel: 'Dlaczego NIROPROD',
      whyTitleStart: 'Zalety',
      whyTitleHighlight: 'systemu na miarę',
      whyText: 'NIROPROD ewoluuje wraz z Twoją firmą. Dzięki platformie Claris FileMaker system dostosowuje się do nowych potrzeb bez migracji ani pełnej wymiany.',
      ctaTitleStart: 'Gotowy do',
      ctaTitleHighlight: 'digitalizacji',
      ctaTitleEnd: 'produkcji?',
      ctaSubtitle: 'Odkryj jak NIROPROD może zmienić Twoje zarządzanie przemysłowe.',
      ctaButton: 'Zaplanuj demo'
    },
    legal: {
      label: 'Informacje',
      titleStart: 'Informacje',
      titleHighlight: 'prawne',
      editorTitle: 'Wydawca strony',
      editorText: 'Strona <strong>ai-dynamics.fr</strong> jest wydawana przez AI Dynamics.',
      editorEmail: 'Email',
      editorPhone: 'Telefon',
      directorTitle: 'Dyrektor publikacji',
      directorText: 'Dyrektorem publikacji jest przedstawiciel prawny AI Dynamics.',
      hostingTitle: 'Hosting',
      hostingText: 'Strona jest hostowana przez dostawcę przestrzegającego europejskich standardów ochrony danych.',
      ipTitle: 'Własność intelektualna',
      ipText1: "Cała zawartość strony (teksty, obrazy, logo, filmy, ilustracje) stanowi wyłączną własność AI Dynamics lub jej partnerów. Wszelkie powielanie, przedstawianie lub dystrybucja, w całości lub części, są surowo zabronione bez uprzedniej pisemnej zgody.",
      ipText2: 'Oprogramowanie NIROPROD jest autorskim produktem AI Dynamics, zbudowanym na platformie Claris FileMaker.',
      linksTitle: 'Linki hipertekstowe',
      linksText: 'Strona może zawierać linki do innych stron internetowych. AI Dynamics nie ponosi odpowiedzialności za zawartość tych stron.',
      lawTitle: 'Prawo właściwe',
      lawText: 'Niniejsza strona podlega prawu francuskiemu. W przypadku sporu, wyłączną jurysdykcję mają sądy francuskie.',
      contactTitle: 'Kontakt',
      contactText: 'W przypadku pytań dotyczących informacji prawnych, skontaktuj się z nami na'
    },
    privacy: {
      label: 'Prywatność',
      titleStart: 'Polityka',
      titleHighlight: 'prywatności',
      intro: 'AI Dynamics zobowiązuje się do ochrony prywatności użytkowników. Niniejsza polityka opisuje sposób zbierania, wykorzystywania i ochrony danych osobowych zgodnie z Ogólnym Rozporządzeniem o Ochronie Danych (RODO).',
      dataTitle: 'Zbierane dane',
      dataIntro: 'Zbieramy tylko dane niezbędne do naszych usług:',
      data1: 'Imię, nazwisko i adres email (formularz kontaktowy)',
      data2: 'Numer telefonu (jeśli podany)',
      data3: 'Nazwa firmy (formularz wyceny)',
      data4: 'Dane techniczne (cookies, adres IP, przeglądarka)',
      purposeTitle: 'Cel przetwarzania',
      purposeIntro: 'Twoje dane są wykorzystywane do:',
      purpose1: 'Odpowiadania na prośby o kontakt lub wycenę',
      purpose2: 'Wysyłania newslettera (za Twoją zgodą)',
      purpose3: 'Ulepszania naszych usług i strony internetowej',
      purpose4: 'Spełniania obowiązków prawnych',
      retentionTitle: 'Okres przechowywania',
      retentionText: 'Twoje dane są przechowywane przez czas niezbędny do celu przetwarzania, maksymalnie 3 lata od ostatniego kontaktu.',
      rightsTitle: 'Twoje prawa',
      rightsIntro: 'Zgodnie z RODO, przysługują Ci następujące prawa:',
      right1Strong: 'Prawo dostępu',
      right1Text: 'do danych osobowych',
      right2Strong: 'Prawo do sprostowania',
      right2Text: 'w przypadku nieścisłości',
      right3Strong: 'Prawo do usunięcia',
      right3Text: 'danych',
      right4Strong: 'Prawo do ograniczenia',
      right4Text: 'przetwarzania',
      right5Strong: 'Prawo do przenoszenia',
      right5Text: 'danych',
      right6Strong: 'Prawo sprzeciwu',
      right6Text: 'wobec przetwarzania',
      rightsContact: 'Aby skorzystać z tych praw, skontaktuj się z nami na',
      cookiesTitle: 'Cookies',
      cookiesText: 'Nasza strona używa plików cookie niezbędnych do prawidłowego działania oraz, za Twoją zgodą, plików analitycznych dla poprawy doświadczenia użytkownika. Możesz zarządzać preferencjami w dowolnym momencie za pomocą banera cookies.',
      securityTitle: 'Bezpieczeństwo',
      securityText: 'Wdrażamy odpowiednie środki techniczne i organizacyjne w celu ochrony danych osobowych przed nieuprawnionym dostępem, ujawnieniem lub modyfikacją.',
      updatesTitle: 'Aktualizacje',
      updatesText: 'Niniejsza polityka może być aktualizowana. Zachęcamy do regularnego jej sprawdzania.',
      contactTitle: 'Kontakt',
      contactText: 'W przypadku pytań dotyczących danych osobowych, skontaktuj się z naszym zespołem na'
    },
    a11y: {
      skipToContent: 'Przejdź do treści głównej',
      backToTop: 'Powrót na górę strony'
    },
    blog: {
      navLabel: 'Blog',
      label: 'Aktualności',
      titleStart: 'Blog',
      titleHighlight: 'AI Dynamics',
      subtitle: 'Analizy, studia przypadków i praktyczne porady na temat automatyzacji, AI i Przemysłu 4.0.',
      categoryAll: 'Wszystkie',
      categoryAutomation: 'Automatyzacja',
      categoryAi: 'Sztuczna Inteligencja',
      categoryCaseStudy: 'Studia przypadków',
      categoryTechmill: 'TECHMILL',
      categoryTech: 'Tech',
      readTime: 'min czytania',
      readMore: 'Czytaj artykuł',
      backToBlog: 'Powrót do bloga',
      shareArticle: 'Udostępnij artykuł',
      relatedTitle: 'Powiązane',
      ctaTitle: 'Potrzebujesz pomocy?',
      ctaSubtitle: 'Nasi eksperci są tutaj, aby transformować Twoje procesy.',
      ctaButton: 'Skontaktuj się',
      notFoundTitle: 'Nie znaleziono artykułu',
      notFoundText: 'Ten artykuł nie istnieje lub został przeniesiony.',
      publishedOn: 'Opublikowano'
    },
    roi: {
      label: 'Kalkulator ROI',
      titleStart: 'Ile mógłbyś',
      titleHighlight: 'zaoszczędzić',
      titleEnd: '?',
      subtitle: 'Oszacuj potencjalne oszczędności w kilka sekund. Wyniki oparte na średnich obserwowanych u naszych klientów.',
      inputTitle: 'Twoja obecna sytuacja',
      currencyLabel: 'Waluta',
      hoursLabel: 'Godziny tygodniowo tracone na zadania powtarzalne',
      hoursHelp: 'Wprowadzanie danych, emaile, raportowanie, planowanie...',
      employeesLabel: 'Liczba osób objętych',
      hourlyCostLabel: 'Średni koszt godzinowy',
      hourlyCostHelp: 'Wynagrodzenie + koszty na osobę',
      automationLabel: '% zadań możliwych do automatyzacji',
      automationHelp: 'Średnio nasze projekty automatyzują 60-80% docelowych zadań',
      resultsTitle: 'Twoje potencjalne zyski',
      weeklyHours: 'godzin/tydzień odzyskanych',
      monthlySavings: 'oszczędności/miesiąc',
      yearlySavings: 'oszczędności/rok',
      paybackTitle: 'Zwrot z inwestycji',
      paybackValue: 'szacowanych miesięcy',
      paybackDesc: 'Na podstawie średniego projektu automatyzacji',
      cta: 'Uzyskaj precyzyjną wycenę',
      disclaimer: 'Te szacunki są orientacyjne. Bezpłatny audyt pozwala na dokładną wycenę Twojego przypadku.'
    },
    chatbot: {
      openLabel: 'Otwórz czat AI',
      title: 'Ada',
      subtitle: 'Asystent AI — AI Dynamics',
      status: 'Online',
      welcome: '👋 Cześć! Jestem Ada, Twój asystent AI. Mogę pomóc Ci odkryć nasze rozwiązania NIROPROD, TECHMILL lub usługi automatyzacji. Co chciałbyś wiedzieć?',
      placeholder: 'Zadaj pytanie...',
      sendLabel: 'Wyślij',
      typing: 'Ada pisze',
      quickActions: 'Szybkie pytania:',
      quickNiroprod: 'Czym jest NIROPROD?',
      quickTechmill: 'Opowiedz mi o TECHMILL',
      quickPrice: 'Jakie są ceny?',
      quickDemo: 'Chcę demo',
      quickContact: 'Jak się z Wami skontaktować?',
      disclaimer: 'Demo AI — po precyzyjną poradę, ',
      disclaimerLink: 'skontaktuj się z ekspertami',
      errorFallback: 'Przepraszam, wystąpił błąd. Możesz też napisać na contact@ai-dynamics.fr',
      poweredBy: 'Napędzane przez AI Dynamics'
    },
    techmillPage: {
      navBack: 'AI Dynamics',
      navCta: 'Poproś o wycenę',
      heroBadge: 'Podwykonawstwo przemysłowe',
      heroTitleStart: 'Twój partner w obróbce',
      heroTitleHighlight: 'precyzyjnych części',
      heroSubtitle: 'TECHMILL by AI Dynamics oferuje kompletne podwykonawstwo części mechanicznych: obróbka, spawanie, obróbka powierzchniowa i montaż. Jakość, terminy, konkurencyjność.',
      heroCtaQuote: 'Poproś o wycenę',
      heroCtaCapabilities: 'Nasze możliwości',
      servicesLabel: 'Nasze Możliwości',
      servicesTitleStart: 'Wieloprocesowe,',
      servicesTitleHighlight: 'jeden zespół',
      servicesSubtitle: 'Od surowca do gotowej części, zarządzamy całym łańcuchem produkcji.',
      advantagesLabel: 'Dlaczego TECHMILL',
      advantagesTitleStart: 'Przewaga',
      advantagesTitleHighlight: 'AI Dynamics',
      advantagesText: 'TECHMILL łączy ekspertyzę przemysłową z narzędziami automatyzacji AI Dynamics. Rezultat: zoptymalizowane terminy, pełna identyfikowalność i płynna komunikacja.',
      devisLabel: 'Wycena',
      devisTitleStart: 'Poproś o',
      devisTitleHighlight: 'wycenę',
      devisSubtitle: 'Opisz swoją potrzebę i otrzymaj propozycję w ciągu 24h.',
      formCompany: 'Firma *',
      formCompanyPlaceholder: 'Twoja firma',
      formEmail: 'Email *',
      formMaterial: 'Materiał',
      formMaterialDefault: 'Wybierz',
      formQuantity: 'Ilość',
      formQuantityPlaceholder: 'Np.: 50 sztuk',
      formDesc: 'Opis potrzeby *',
      formDescPlaceholder: 'Opisz części, tolerancje, wymagane obróbki...',
      formUpload: 'Upuść tu pliki techniczne (rysunki, STEP, PDF) — Wkrótce dostępne',
      formSubmit: 'Wyślij zapytanie ofertowe',
      footerTagline: 'Wieloprocesowe podwykonawstwo przemysłowe.'
    }
  }
};

export default translations;
